import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2317">
      <Navbar data-id="element-2318" />
      <main data-id="element-2319">
        <ConsularAffairs data-id="element-2320" />
      </main>
      <Footer data-id="element-2321" />
      <FeedbackPopup data-id="element-2322" />
    </div>;
}